import MatchedMap from 'utilities/src/matchedMap';

const languageMap = new MatchedMap<string, { code: string; name: string }>([
  ['bash', { code: 'bash', name: 'Bash / Shell' }],
  ['css', { code: 'css', name: 'CSS' }],
  ['html', { code: 'html', name: 'HTML' }],
  ['js', { code: 'javascript', name: 'JavaScript' }],
  ['json', { code: 'json', name: 'JSON' }],
  ['php', { code: 'php', name: 'PHP' }],
  ['sql', { code: 'sql', name: 'SQL' }],
  ['ts', { code: 'typescript', name: 'TypeScript' }],
  ['_', { code: '', name: 'Code' }],
]);

/**
 * Types
 */

type GetCodeAndLanguageProps = {
  codeSection: string;
};

/**
 * Hook
 */

export default function getCodeAndLanguage({ codeSection }: GetCodeAndLanguageProps) {
  const code = codeSection
    .replace(/<[^>]*>/g, '')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\n$/, '');

  const lng = codeSection.match(/class="language-(.*?)"/)?.[1] ?? '';
  const language = languageMap.get(lng);

  return { code, language };
}
